export default async function ({ $axios, store }) {
    await $axios.$get('/config').then((res) => {
        if (res.success === 1) {
            store.commit('data/setPrice', res.data.brutto_price);
        }
    });
}
